import React from "react";
import { DialogActions, DialogButton } from '@rmwc/dialog';

export default function ActionButtons({
    cancelText,
    acceptText,
    onClickCancel,
    onClickAccept,
    cancelDisabled,
    acceptDisabled,
    acceptVariant = 'primary'
}) {
    return (
        <div className='coa-inner-action-buttons'>
            <DialogActions>
                <DialogButton
                    className="coa-dialog-button coa-dialog-button-cancel"
                    action="close"
                    disabled={!!cancelDisabled && cancelDisabled}
                    onClick={onClickCancel}
                >{cancelText}
                </DialogButton>
                <DialogButton
                    className={`coa-dialog-button ${acceptVariant === "danger" ? 'coa-dialog-button-accept-danger' : 'coa-dialog-button-accept'}`}
                    action="accept"
                    danger={acceptVariant === 'danger'}
                    disabled={!!acceptDisabled && acceptDisabled}
                    isDefaultAction
                    onClick={onClickAccept}
                    >{acceptText}
                </DialogButton>
            </DialogActions>
        </div>
    )
}